import React from 'react';

const ToastCustom = ({ message, onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: '#333',
      color: '#fff',
      padding: '10px 20px',
      borderRadius: '5px',
      zIndex: 1000,
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
    }}>
      {message}
      <button onClick={onClose} style={{
        marginLeft: '10px',
        backgroundColor: 'transparent',
        border: 'none',
        color: '#fff',
        cursor: 'pointer'
      }}>✖</button>
    </div>
  );
};

export default ToastCustom;
